module.exports = __webpack_public_path__ + "img/P34-en.4de31a80.png";